<template>
  <div class="pages">
    <!-- <div class="top-search-nav">
      <div class="top-search-box" :style="tran">
        <div class="search-menu" @click="gotoSign">
          <img src="@/assets/home/i.png" class="i-icon" />
        </div>
        <div class="search">
          <div class="placeholder" @click="searchInputfocus">
            <img src="@/assets/f-w.png" class="search-icon" />
            <span>搜索老师，文章</span>
          </div>
        </div>
        <div class="search-menu" @click="goto">
          <img src="@/assets/home/k.png" class="k-icon" />
        </div>
      </div>
    </div> -->
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>

    <div class="banner" id="banner">
      <swipe class="my-swipe" :autoplay="3000" @change="onChange">
        <swipe-item
          v-for="(item, index) in swipe"
          :key="index"
          @click="goPage(item.type, item.jump)"
        >
          <img
            v-lazy="item.thumb"
            :key="item.thumb"
            style="width:100%;height:100%;object-fit: cover;"
          />
        </swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            <div
              v-for="(item, index) in swipe"
              :key="index"
              :class="[
                index == current
                  ? 'custom-indicator-item-action'
                  : 'custom-indicator-item',
              ]"
            ></div>
          </div>
        </template>
      </swipe>
    </div>

    <div class="content" id="content">
      <div class="head-nav" id="head-nav">
        <div @click="gotowx">
          <img src="../../assets/home/zhaolaoshi.png" alt="" />
          <div>
            <p>找老师</p>
            <p>一对一专业咨询</p>
          </div>
        </div>
        <!-- <div @click="$router.push({ path: '/ask' })">
          <img src="../../assets/home/wendatiwen.png" alt="" />
          <div>
            <p>问答提问</p>
            <p>已有{{ questionNum }}次回答</p>
          </div>
        </div> -->
      </div>

      <div class="modular">
        <div class="menu" id="menu">
          <!-- <swipe class="swipe-menu" @change="(i) => (menucurrent = i)">
            <swipe-item
              v-for="(item, index) in Math.ceil(menu.length / 8)"
              :key="index"
            >
              <div class="swipe-menu-items">
                <template v-for="(it, i) in menu">
                  <div
                    :key="i"
                    v-if="i >= index * 8 && i < (index + 1) * 8"
                    @click="clickMenu(it)"
                  >
                    <img :src="it.icon" alt="" />
                    <p>{{ it.text }}</p>
                  </div>
                </template>
              </div>
            </swipe-item>
            <template #indicator v-if="menu.length > 8">
              <div class="custom-indicator">
                <div
                  v-for="(item, index) in Math.ceil(menu.length / 8)"
                  :key="index"
                  :class="[
                    index == menucurrent
                      ? 'custom-indicator-item-action'
                      : 'custom-indicator-item',
                  ]"
                ></div>
              </div>
            </template>
          </swipe> -->
          <div class="swipe-menu-items">
            <template v-for="(it, i) in menu">
              <div
                :key="i"
                @click="clickMenu(it)"
              >
                <img :src="it.icon" alt="" />
                <p>{{ it.text }}</p>
              </div>
            </template>
          </div>
        </div>

        <!-- <div class="notice">
          <i class="iconfont icon-lingdangwudian" style="color: #f05468"></i>
          <swipe
            class="notice-swipe"
            autoplay="2000"
            :touchable="false"
            vertical
            :show-indicators="false"
          >
            <swipe-item
              v-for="(item, index) in data.msgs"
              :key="index"
              v-html="msg(item)"
            >
            </swipe-item>
          </swipe>
        </div> -->

        <div class="fortune" id="fortune">
          <div class="fortune-nav">
            <!-- <div :class="{ action: yscurrent == 0 }" @click="yscurrent = 0">
              今日运势报告
            </div> -->
            <!-- <div style="flex: 0">|</div> -->
            <div :class="{ action: yscurrent == 1 }" @click="yscurrent = 1">
              五行分析
            </div>
          </div>

          <div class="fortune-con">
            <!-- <div class="option">
              <span>姓名：</span>
              <div class="option-con">
                <input type="text" placeholder="请输入姓名" v-model="name" />
              </div>
            </div> -->
            <template>
              <div class="option">
                <span>性别：</span>
                <div class="option-con">
                  <div class="sex">
                    <div @click="sex = 1">
                      <div :class="sex == 1 ? 'radio-check' : 'radio'"></div>
                      <span>男</span>
                    </div>
                    <div @click="sex = 0">
                      <div :class="sex == 0 ? 'radio-check' : 'radio'"></div>
                      <span>女</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="option" @click="selectDate">
                <span>出生年月日：</span>
                <div class="option-con">
                  <!-- <span class="placeholder">请选择出生年月日</span> -->
                  <span class="placeholder">{{ date }}</span>
                </div>
                <i class="iconfont icon-a-LeftArrow"></i>
              </div>

              <div class="option" @click="selectTime">
                <span>出生时辰：</span>
                <div class="option-con">
                  <span class="placeholder">{{ time }}</span>
                </div>
                <i class="iconfont icon-a-LeftArrow"></i>
              </div>
            </template>

            <div class="buton" @click="submit">确认</div>
            <div style="font-size:.25rem;margin-top:.1rem">
              页面展示个人信息仅储存在您的手机，本站服务器不会收集任何关联信息，请放心使用。
            </div>
            <!-- <div class="perfect-info">
              <div class="calendar">
                <div class="spot"></div>
                <span v-if="data.fortune && user && user.isPerfect">
                  ({{ user.lunar == 0 ? "公历" : "农历" }}){{
                    user.year.split("-")[0]
                  }}年{{ user.year.split("-")[1] }}月{{
                    user.year.split("-")[2]
                  }}日
                  {{ user.time.split(" ")[0] }}
                </span>
                <span v-if="!user" style="color: #999999"
                  >登录可查看今日运势</span
                >
                <span v-if="user && user.isPerfect == 0" style="color: #999999"
                  >完善信息可查看今日运势</span
                >
              </div>
              <div
                class="ws-inof"
                @click="$router.push('editUser')"
                v-if="!(user && user.isPerfect && data.fortune)"
              >
                <i class="iconfont icon-bi"></i>
                <span>完善信息</span>
              </div>
            </div> -->

            <!-- <div class="today-ys" v-show="yscurrent == 0">
              <div class="percent">
                <p class="bfb">
                  {{
                    (user &&
                      user.isPerfect &&
                      data.fortune &&
                      data.fortune.fortune) ||
                      0
                  }}%
                </p>
                <p class="bfb-t">今日运势值</p>
              </div>
              <div class="star-ys">
                <div>
                  <span>桃花运</span>
                  <div class="star">
                    <stars
                      :num="
                        (user &&
                          user.isPerfect &&
                          data.fortune &&
                          data.fortune.blossom) ||
                          0
                      "
                    />
                  </div>
                </div>
                <div>
                  <span>财富运</span>
                  <div class="star">
                    <stars
                      :num="
                        (user &&
                          user.isPerfect &&
                          data.fortune &&
                          data.fortune.wealth) ||
                          0
                      "
                    />
                  </div>
                </div>
                <div>
                  <span>工作运</span>
                  <div class="star">
                    <stars
                      :num="
                        (user &&
                          user.isPerfect &&
                          data.fortune &&
                          data.fortune.work) ||
                          0
                      "
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="ys-btns" v-show="yscurrent == 0">
              <div @click="$router.push('sx')">生肖运势</div>
              <div @click="$router.push('xz')">星座运势</div>
            </div> -->

            <!-- <div class="fiveElements" v-show="yscurrent == 1">
              <div class="iam">
                <div class="five-tile">我是</div>
                <div
                  class="iam-m"
                  :style="data.fiveElements ? data.fiveElements.lifec : ''"
                >
                  {{ data.fiveElements ? data.fiveElements.life : "" }}
                </div>
              </div>
              <div class="my-five">
                <div class="five-tile">我的五行</div>
                <div class="five">
                  <span
                    :style="data.fiveElements ? data.fiveElements.year1c : ''"
                  >
                    {{ data.fiveElements ? data.fiveElements.year1 : "" }}
                  </span>
                  <span
                    :style="data.fiveElements ? data.fiveElements.month1c : ''"
                    >{{
                      data.fiveElements ? data.fiveElements.month1 : ""
                    }}</span
                  >
                  <span
                    :style="data.fiveElements ? data.fiveElements.day1c : ''"
                    >{{ data.fiveElements ? data.fiveElements.day1 : "" }}</span
                  >
                  <span
                    :style="data.fiveElements ? data.fiveElements.time1c : ''"
                    >{{
                      data.fiveElements ? data.fiveElements.time1 : ""
                    }}</span
                  >
                  <span
                    :style="data.fiveElements ? data.fiveElements.year2c : ''"
                    >{{
                      data.fiveElements ? data.fiveElements.year2 : ""
                    }}</span
                  >
                  <span
                    :style="data.fiveElements ? data.fiveElements.month2c : ''"
                    >{{
                      data.fiveElements ? data.fiveElements.month2 : ""
                    }}</span
                  >
                  <span
                    :style="data.fiveElements ? data.fiveElements.day2c : ''"
                    >{{ data.fiveElements ? data.fiveElements.day2 : "" }}</span
                  >
                  <span
                    :style="data.fiveElements ? data.fiveElements.time2c : ''"
                    >{{
                      data.fiveElements ? data.fiveElements.time2 : ""
                    }}</span
                  >
                </div>
              </div>
            </div> -->
            <!-- <div
              class="five-analysis"
              v-show="yscurrent == 1 && user && user.isPerfect"
              @click="$router.push('wx')"
            >
              五行分析
            </div> -->
          </div>
        </div>

        <!-- <div class="teacher">
          <div class="modular-title">
            <div class="title-left">
              <div class="title-line"></div>
              <div>推荐老师</div>
            </div>
            <div
              class="look-more"
              @click="$router.push({ path: '/teacherList' })"
            >
              <span>查看更多</span>
              <i class="iconfont icon-a-LeftArrow"></i>
            </div>
          </div>

          <div class="lss" v-if="data.teachers2 && data.teachers2.length">
            <div
              class="ls"
              v-for="(item, index) in data.teachers2"
              :key="index"
            >
              <div class="ls-img">
                <img 
                  v-lazy="item.recommend_thumb"
                  :key="item.recommend_thumb"
                  style="width:100%;height:100%;object-fit: cover;"
                  />
              </div>
              <p class="ls-name">{{ item.username }}</p>
              <p class="van-multi-ellipsis--l3 ls-jj">
                {{ item.introduction }}
              </p>

              <div class="ljzx">
                <div
                  class="ljzx-btn"
                  @click="
                    $router.push({
                      path: 'teacherDetails',
                      query: { id: item.id },
                    })
                  "
                >
                  立即咨询
                </div>
                <p class="jd-num">{{ item.answer_num }}解答</p>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="video">
          <div class="modular-title">
            <div class="title-left">
              <div class="title-line"></div>
              <div>推荐好课</div>
            </div>
            <div class="look-more" @click="jump_page('kclist')">
              <span>查看更多</span>
              <i class="iconfont icon-a-LeftArrow"></i>
            </div>
          </div>
          <kevideo :list="data.curriculum" />
        </div> -->

        <div class="article">
          <!-- <div class="modular-title">
            <div class="title-left">
              <div class="title-line"></div>
              <div>文章资讯</div>
            </div>
            <div class="look-more" @click="$router.push('/wzlist')">
              <span>查看更多</span>
              <i class="iconfont icon-a-LeftArrow"></i>
            </div>
          </div> -->

          <!-- <div
            class="wz"
            v-for="(item, index) in data.articles"
            :key="index"
            @click="
              $router.push({ path: '/wzdetails', query: { id: item.id } })
            "
          >
            <div class="wz-pos">
      
              <img
                v-lazy="item.thumb"
                :key="item.thumb"
                style="width:100%;height:100%;object-fit: cover;"
              >
            </div>
            <div
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="wz-title">
                <p>{{ item.title }}</p>
              </div>
              <div class="wz-time">
                <span>{{ item.time }}</span>
                <span>已有{{ item.read }}人阅读</span>
              </div>
            </div>
          </div> -->
          <div
            class="wz"
            style="border-bottom:0"
            v-for="(item, index) in artlist"
            :key="index"
            
          >
            <div class="modular-title">
              <div class="title-left">
                <div class="title-line"></div>
                <div>{{ index }}</div>
              </div>
              <div class="look-more" @click="gotoD(index)">
                <span>查看更多</span>
                <i class="iconfont icon-a-LeftArrow"></i>
              </div>
            </div>
            <div
              v-for="(item1, index2) in item"
              :key="index2"
              class="wz"
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
              @click="gotoDt(item1.id)"
            >
              <div class="wz-title">
                <p>{{ item1.title }}</p>
              </div>
              <div class="wz-time">
                <span>{{ item1.created_time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <select-date
      v-model="show"
      :lunar="lunar"
      @confirm="dateConfirm"
      :date="date"
    />

    <select-time v-model="showTime" :date="time" @confirm="timeConfirm" />

    <bottom></bottom>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-12
@create:wq
*/
import { Swipe, SwipeItem } from "vant";
import kevideo from "../../components/kcvideo.vue";
import stars from "@/components/stars";
import topTab from "@/components/topTab";
import { getCode, shareJsSdk ,qywx} from "@/utils/tool";
import selectDate from "@/components/selectDate.vue";
import selectTime from "@/components/selectTime.vue";
import bottom from "@/components/bottom.vue";
import { getQueryString } from '../../utils/tool';
export default {
  name: "home",
  props: {},
  components: {
    Swipe,
    SwipeItem,
    kevideo,
    stars,
    topTab,
    selectDate,
    selectTime,
    bottom,
  },
  data() {
    return {
      tran: {},
      artlist: {},
      swipe: [],
      current: 0,
      menucurrent: 0,
      questionNum: "",
      name: "",
      sex: 1,
      show: false,
      showTime: false,
      date: "请选择出生年月日",
      time: "请选择出生时辰",
      lunar: 0,
      is_teacher: 0,
      rout: [
        {
          name: "首页",
          path: "/home",
        },
      ],
      menu: [
        {
          icon: require("../../assets/home/1.png"),
          text: "称骨算命",
          id: 1,
          url: "cg",
        },
        {
          icon: require("../../assets/home/2.png"),
          text: "扑克占卜",
          id: 2,
          url: "pk",
        },
        {
          icon: require("../../assets/home/3.png"),
          text: "生肖算命",
          id: 3,
          url: "sxsm",
        },
        {
          icon: require("../../assets/home/4.png"),
          text: "生命灵数",
          id: 4,
          url: "smls",
        },
        {
          icon: require("../../assets/home/5.png"),
          text: "生肖配对",
          id: 5,
          url: "sxpd",
        },
        {
          icon: require("../../assets/home/6.png"),
          text: "号码吉凶",
          id: 6,
          url: "numjx",
        },
        {
          icon: require("../../assets/home/7.png"),
          text: "星座配对",
          id: 7,
          url: "xzpd",
        },
        {
          icon: require("../../assets/home/8.png"),
          text: "血型配对",
          id: 8,
          url: "xxpd",
        },
        {
          icon: require("../../assets/home/9.png"),
          text: "指纹吉凶",
          id: 8,
          url: "zwjx",
        },
        {
          icon: require("../../assets/home/10.png"),
          text: "眼跳吉凶",
          id: 8,
          url: "ytjx",
        },
        {
          icon: require("../../assets/home/11.png"),
          text: "周公解梦",
          id: 8,
          url: "zgjm",
        },
        {
          icon: require("../../assets/home/12.png"),
          text: "日历",
          id: 8,
          url: "calendar",
        },
      ],
      yscurrent: 1,
      data: "",
      roomId: "",
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : null,
    };
  },
  computed: {
    msg() {
      return function(msg) {
        let n = msg.msg.replace(
          msg.tname,
          `<span style="color:#EC566C">${msg.tname}</span>`
        );
        return n;
      };
    },
  },
  watch: {},
  mounted() {},
  created() {
    // window.addEventListener("scroll", this.handleScroll);
    getCode();
    this.art();

    
    // const userinfo = JSON.parse(localStorage.getItem("user"));
    // this.lunar = userinfo.lunar;
    // this.date = userinfo.year ? userinfo.year : "请选择出生年月日";
    // this.time = userinfo.time ? userinfo.time : "请选择出生时辰";
    // this.sex = userinfo.sex ? userinfo.sex : 1;
    // this.is_teacher = userinfo.is_teacher;
    // if(this.is_teacher){
    //   this.name = userinfo.name;
    // }else{
    //   this.name = userinfo.username;
    // }
    // let url = window.location.href.toString();
    // let u1 = url.indexOf('?usercode=');
    // if(u1 >= 0){
    //   let u2 = url.indexOf('#/');
    //   let u3 = url.indexOf('=');
    //   let usercode = url.substr(u3 + 1,u2-u3-1);
    //   sessionStorage.setItem('userCode',usercode);
    //   console.log(url,usercode);
    //   window.location.href='http://keyiche.anagelink.cn/h5/'
    // }
    this.getData();
    if (this.user) {
      this.msgPageNum();
      this.getServiceRoomeId();
    }
    shareJsSdk("home", "可以测", "国学传统文化 在线一对一咨询平台");
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    gotowx(){
      window.location = qywx
    },
    selectDate() {
      this.show = true;
    },
    selectTime() {
      this.showTime = true;
    },
    submit() {
      if (!this.date || this.date == '请选择出生年月日') return this.Toast("请选择您的出生年月日");
      if (!this.time || this.time == '请选择出生时辰') return this.Toast("请选择您的出生时辰");
      this.$router.push(
        `/wx?lune=${this.lunar}&time=${this.time}&date=${this.date}&sex=${this.sex}`
      );
    },
    timeConfirm(data) {
      this.time = data.date;
    },
    dateConfirm(data) {
      this.lunar = data.lunar;
      this.date = data.date;
    },
    msgPageNum() {
      this.api.msgPageNum().then((res) => {
        this.$store.dispatch("app/setNum", res.data.msgPageNum);
      });
    },
    gotoSign() {
      if (this.user) {
        this.$router.push({ path: "/sign" });
      } else {
        this.Toast("请登录后操作");
      }
    },
    getData() {
      this.api.getIndex().then((res) => {
        this.swipe = res.data.adv;
        this.data = res.data;
        let questionNum = Number(res.data.questions_answers_num);
        if (questionNum > 10000 && questionNum < 1000000) {
          this.questionNum =
            (questionNum % 10000 == 0
              ? questionNum / 10000
              : (questionNum / 10000).toFixed(2)) + "万";
        } else if (questionNum > 1000000) {
          this.questionNum =
            (questionNum % 100000 == 0
              ? questionNum / 100000
              : (questionNum / 1000000).toFixed(2)) + "百万";
        } else {
          this.questionNum = questionNum;
        }
        this.getDataColor();

        this.$nextTick(() => {
          if(getQueryString('to')){
            console.log(document.getElementById("banner").offsetHeight + document.getElementById('head-nav').offsetHeight + document.getElementById('menu').offsetHeight);
            window.scrollTo({
              top:document.getElementById("banner").offsetHeight + document.getElementById('head-nav').offsetHeight + document.getElementById('menu').offsetHeight
            })
          }
        })
      });
    },
    art() {
      this.api.getArticle().then((res) => {
        this.artlist = res.data;
      });
    },
    getDataColor() {
      //#F9BD77 -甲乙寅卯   #EF91A1-丙丁巳午  #CBA48A-戊己辰戌丑未；
      //#EEDC84 -庚辛申酉   #77E0F1-壬癸亥子
      if (!this.data) return;
      let d = this.data.fiveElements ? this.data.fiveElements : "";
      if (!d) return;
      d.year1c = this.colorSet(d.year1);
      d.month1c = this.colorSet(d.month1);
      d.day1c = this.colorSet(d.day1);
      d.time1c = this.colorSet(d.time1);
      d.year2c = this.colorSet(d.year2);
      d.month2c = this.colorSet(d.month2);
      d.day2c = this.colorSet(d.day2);
      d.time2c = this.colorSet(d.time2);
      d.lifec = this.colorSet(d.life.substring(0, 1), true);
      let a = "戊";
      let b = "戊己辰戌丑未";
      // console.log(b.indexOf(a), 999);
    },
    colorSet(d, t = false) {
      let c;
      let f = "color:";
      let arr;
      if (!t) {
        arr = [
          {
            font: "甲乙寅卯",
            color: "#F9BD77",
          },
          {
            font: "丙丁巳午",
            color: "#EF91A1",
          },
          {
            font: "戊己辰戌丑未",
            color: "#CBA48A",
          },
          {
            font: "庚辛申酉",
            color: "#EEDC84",
          },
          {
            font: "壬癸亥子",
            color: "#77E0F1",
          },
        ];
      } else {
        arr = [
          {
            font: "木",
            color: "#F9BD77",
          },
          {
            font: "火",
            color: "#EF91A1",
          },
          {
            font: "土",
            color: "#CBA48A",
          },
          {
            font: "金",
            color: "#EEDC84",
          },
          {
            font: "水",
            color: "#77E0F1",
          },
        ];
      }

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].font.indexOf(d) >= 0) {
          c = arr[i].color;
          break;
        }
      }
      return f + (c ? c : "#000");
    },
    searchInputfocus() {
      // this.showSearchInput = true;
      // this.$nextTick(function () {
      //   //DOM 更新了
      //   this.$refs.searchInput.focus();
      // });
      this.$router.push({ path: "/search" });
    },
    onChange(index) {
      this.current = index;
    },
    //滚动改变顶部透明度
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      let offsetTop = document.querySelector("#content").offsetTop; // 要滚动到顶部吸附的元素的偏移量
      // let isFixed = scrollTop > offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
      let transparency = scrollTop / offsetTop;
      this.tran = {
        background: `rgba(79, 217, 213, ${transparency})`,
      };
    },
    goto() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      this.$router.push({
        path: "SERVECHAT",
        query: {
          id: this.roomId,
          oid: 0,
          s: 0,
          t: 0,
          remind: 0,
        },
      });
      // if (localStorage.getItem("user")) {
      //   let user = JSON.parse(localStorage.getItem("user"));
      //   if (user.is_teacher == 0) {
      //     this.$router.replace({ path: "/mine" });
      //   } else {
      //     this.$router.replace({ path: "/tmine" });
      //   }
      // } else {
      //   this.$router.replace({ path: "/mine" });
      // }
    },
    getServiceRoomeId() {
      this.api.getServiceRoomeId().then((res) => {
        this.roomId = res.data.roomId;
      });
    },
    jump_page(name) {
      this.$router.push(name);
    },

    clickMenu(item) {
      if (item.url) this.$router.push(item.url);
    },
    goPage(type, jump) {
      if (type == 1) {
        this.$router.push({ path: "/teacherDetails", query: { id: jump } });
      } else if (type == 2) {
        // this.$router.push({ path: "/wzdetails", query: { id: jump, type: 2 } });
        this.$router.push({ path: "/lunbpage", query: { id: jump, type: 2 } });
      }
    },
    gotoD(type){
      window.location = 'articleList/articleList_'+type+'.html'
    },
    gotoDt(id){
      window.location = 'articleList/articleDetail_'+id+'.html'
    }
  },
};
</script>
<style lang="scss" scoped>
// .pages{
//   padding-top: 1.2rem;
// }
.banner {
  height: 6rem;
  .my-swipe {
    width: 100%;
    // width: 7.5rem;

    // position: fixed;
    top: 0;
    // left: 0;
    // right: 0;
    z-index: 1;
  }
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 6rem;
  background-color: rgba($color: #000000, $alpha: 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    // height: 100%;
  }
}
.custom-indicator {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  .custom-indicator-item {
    width: 8px;
    height: 8px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    margin-right: 8px;
  }
  .custom-indicator-item-action {
    width: 16px;
    height: 8px;
    background: #4fd9d5;
    border-radius: 4px;
    margin-right: 8px;
  }
}
.top-search-box {
  width: 7.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14px;

  position: sticky;
  top: 0;
  // right: 0;
  // left: 0;
  z-index: 10;

  .search-menu {
    width: 47px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.4rem;
    color: #ffffff;
    img.i-icon {
      width: 0.4rem;
      height: 0.44rem;
    }
    img.k-icon {
      width: 0.46rem;
      height: 0.42rem;
    }
  }
  .search {
    flex: 1;
    background-color: rgba($color: #000000, $alpha: 0.6);
    height: 34px;
    border-radius: 20px;
    overflow: hidden;
    opacity: 0.6;
    input {
      width: 100%;
      height: 100%;
      background-color: transparent;
      border: none;
      color: white;
      padding: 0 20px;
      // text-align: center;
    }
    .placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      .search-icon {
        width: 0.35rem;
        height: 0.35rem;
        margin-right: 0.08rem;
      }
    }
  }
}
.content {
  // height: 100px;
  width: 100%;
  // background-color: red;
  border-radius: 30px 30px 0 0;
  overflow: hidden;
  margin-top: -30px;
  position: relative;
  z-index: 1;

  background-color: #eff5fb;
  .head-nav {
    padding: 0.32rem 0.24rem 0.28rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
      // width: 3.44rem;
      width: 100%;
      height: 1.08rem;
      border-radius: 0.54rem;
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-content: center;
      padding: 0.12rem;
      box-sizing: border-box;
      > img {
        width: 0.84rem;
        margin-right: 0.5rem;
        // margin-right: 0.26rem;
      }

      font-size: 0.2rem;
      font-weight: 400;

      p:first-child {
        font-size: 0.3rem;
        font-weight: bold;
        color: #666666;
      }
    }
  }

  .modular {
    border-radius: 30px 30px 0 0;
    overflow: hidden;
    background-color: #ffffff;
    padding-top: 22px;
    .swipe-menu {
      // height: 4.7rem;
      .swipe-menu-items {
        min-height: 4rem;
        display: flex;
        flex-wrap: wrap;
        > div {
          width: calc(100% / 4);
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 13px;

          font-size: 0.24rem;
          font-weight: 400;
          color: #666666;

          img {
            width: 1.2rem;
            height: 1.2rem;
            box-shadow: 0px 6px 12px rgba(253, 248, 229, 0.2);
            margin-bottom: 3px;
            // border-radius: 10px;
          }
        }
      }
      .custom-indicator {
        bottom: 0px;
      }
      .custom-indicator-item {
        background: rgba(0, 0, 0, 0.2);
      }
    }

    .notice {
      margin: 0.26rem 0.24rem;
      height: 0.8rem;
      background: #f6f8f8;
      border-radius: 11px;
      overflow: hidden;
      padding: 0 0.26rem;
      display: flex;
      align-items: center;

      .notice-swipe {
        width: 100%;
        height: 0.8rem;
        line-height: 0.8rem;
        padding-left: 0.18rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #999999;
        span {
          color: #ec566c;
        }
      }
    }

    .fortune {
      margin: 0.26rem 0.24rem;

      // height: 5.08rem;
      background: #ffffff;
      // box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      // border-radius: 16px;
      overflow: hidden;

      .fortune-nav {
        display: flex;
        background: #f6f8f8;
        font-size: 0.3rem;
        color: #666666;
        height: 0.86rem;
        > div {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 2px solid transparent;
        }
        .action {
          color: #4fd9d5;
          border-bottom: 2px solid #4fd9d5;
        }
      }
      .fortune-con {
        // padding: 2px 6px;

        .perfect-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.22rem 0;
          border-bottom: 1px solid #f0f0f0;
          box-sizing: border-box;
          > div {
            display: flex;
            align-items: center;
          }
          .calendar {
            font-size: 0.28rem;
            font-weight: 400;
            color: #333333;
            .spot {
              width: 6px;
              height: 6px;
              background: #4fd9d5;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
          .ws-inof {
            font-size: 0.22rem;
            font-weight: 400;
            color: #4fd9d5;
            .icon-bi {
              color: #34c290;
              margin-right: 5px;
            }
          }
        }

        .today-ys {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 0.5rem;
          .percent {
            margin-right: 0.7rem;
            text-align: center;
            .bfb {
              font-size: 0.42rem;
              font-family: PingFang-SC-Bold;
              color: #f07954;
            }
            .bfb-t {
              font-size: 0.24rem;
              font-weight: 400;
              color: #999999;
            }
          }

          .star-ys {
            border-left: 1px solid #f0f0f0;
            padding-left: 0.56rem;
            > div {
              display: flex;
              align-items: center;
              margin-bottom: 0.1rem;
              &:last-child {
                margin-bottom: 0;
              }
            }
            span {
              font-size: 0.22rem;
              font-family: PingFang-SC-Medium;
              color: #999999;
              margin-right: 0.4rem;
            }
            i {
              font-size: 0.3rem;
              color: #cccccc;
              margin-right: 0.18rem;
            }
          }
        }
        .ys-btns {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0.4rem 0.38rem 0;
          > div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.78rem;
            height: 0.72rem;
            background: #4fd9d5;
            border-radius: 0.7rem;

            font-size: 0.26rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }
        .fiveElements {
          display: flex;
          margin-top: 0.2rem;
          .iam {
            flex: 1;
          }
          .iam-m {
            font-size: 0.42rem;
            font-weight: 400;
            color: #f07954;
            text-align: center;
            margin-top: 0.4rem;
          }
          .five-tile {
            font-size: 0.24rem;
            font-weight: 400;
            color: #999999;
            margin-bottom: 0.08rem;
          }
          .my-five {
            width: 4.22rem;
            .five {
              padding: 0.12rem 0;
              background: rgba($color: #4fd9d5, $alpha: 0.1);
              font-size: 0.28rem;
              font-weight: 400;
              color: #428cee;
              display: flex;
              flex-wrap: wrap;
              span {
                width: calc(100% / 4);
                text-align: center;
                margin-bottom: 0.24rem;
              }
            }
          }
        }
        .five-analysis {
          background: #4fd9d5;
          color: #ffffff;
          font-size: 0.26rem;
          font-weight: 400;
          height: 0.72rem;
          border-radius: 0.7rem;
          margin-top: 0.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .modular-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-left {
        font-size: 0.32rem;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;
        .title-line {
          width: 4px;
          height: 16px;
          background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
          opacity: 1;
          border-radius: 0px 4px 4px 0px;
          margin-right: 6px;
        }
      }
      .look-more {
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
        span {
          margin-right: 6px;
        }
        i {
          font-size: 0.2rem;
        }
      }
    }

    .teacher {
      margin: 0.4rem 0.24rem;
      .lss {
        padding: 10px;
        display: flex;
        overflow-x: auto;
      }
      .ls {
        width: 2.88rem;
        height: 4.24rem;
        background: #ffffff;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        position: relative;
        // overflow: hidden;
        padding: 0 0.28rem;
        padding-top: 0.8rem;
        margin-top: 0.8rem;
        margin-right: 0.26rem;

        box-sizing: border-box;

        .ls-img {
          width: 1.28rem;
          height: 1.28rem;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, -50%);
          img {
            width: 100%;
          }
        }
        .ls-name {
          font-size: 0.28rem;
          font-weight: bold;
          color: #333333;
          text-align: center;
        }
        .ls-jj {
          font-size: 0.24rem;
          color: #999999;
          margin-top: 5px;
          min-height: 1.2rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
        .ljzx {
          border-top: 1px dotted #cccccc;
          margin-top: 0.2rem;
          padding-top: 0.2rem;
          .ljzx-btn {
            width: 2.38rem;
            height: 0.6rem;
            background: rgba(79, 217, 213, 0.1);
            border: 1px solid #4fd9d5;
            border-radius: 15px;
            box-sizing: border-box;

            font-size: 0.26rem;
            font-weight: 400;
            color: #4fd9d5;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .jd-num {
            font-size: 0.24rem;
            color: #cccccc;
            text-align: center;
            margin-top: 0.18rem;
          }
        }
      }
    }
    .video {
      margin: 0.4rem 0.24rem;
      .sp {
        margin: 0.28rem 0;

        border-radius: 0.28rem;
        overflow: hidden;
        .pos {
          width: 100%;
          height: 3.05rem;
          overflow: hidden;
          position: relative;
          img {
            width: 100%;
          }
          .play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            i {
              color: white;
              font-size: 32px;
            }
          }
        }
        .sp-info {
          padding: 0.26rem;
          background: #f5f5f5;
          .sp-title {
            font-size: 0.28rem;
            font-weight: 400;
            color: #333333;
          }
          .sp-state {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .sp-s {
              font-size: 0.24rem;
              font-weight: 400;
              color: #2edb79;
            }

            .eye {
              font-size: 0.24rem;
              font-weight: 400;
              color: #cccccc;
              i {
                color: #999999;
                font-size: 0.27rem;
              }
            }
          }
        }
      }
    }

    .article {
      margin: 0.4rem 0.24rem;
      .wz {
        padding: 0.32rem 0 0.26rem;
        border-bottom: 1px solid #f4f4f4;
        .wz-pos {
          // flex-shrink: 0;
          width: 2.15rem;
          height: 1.62rem;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 0.32rem;
        }
        
      }
      .wz-title {
        width: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .wz-time {
        width: 100%;
        margin-top: 0.3rem;
        font-size: 0.24rem;
        font-weight: 300;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color:#a1a1a1;
      }
    }
  }
}
.option {
  display: flex;
  align-items: center;
  font-size: 0.3rem;
  color: #333333;
  border-bottom: 1px solid #dddddd;
  padding: 0.3rem 0;
  .option-con {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    input {
      width: 100%;
      border: none;
      outline: none;
    }
    > span {
      width: 100%;
    }
    .sex {
      display: flex;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
        margin-right: 100px;
        span {
          margin-left: 15px;
        }
      }
    }
    .placeholder {
      color: #999999;
    }
  }
  i {
    color: #cccccc;
    font-size: 12px;
  }
}
.buton {
  margin-top: 20px;
}
.swipe-menu-items {
  min-height: 4rem;
  display: flex;
  flex-wrap: wrap;
  > div {
    width: calc(100% / 4);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 13px;

    font-size: 0.24rem;
    font-weight: 400;
    color: #666666;

    img {
      width: 1.2rem;
      height: 1.2rem;
      box-shadow: 0px 6px 12px rgba(253, 248, 229, 0.2);
      margin-bottom: 3px;
      // border-radius: 10px;
    }
  }
}
</style>
